import { useState, useEffect } from "react";
import "./index.css";
import i18n from "../../i18n";
import dashGlobe from "../../assets/shapes_svg/dashboards/dash-globe.svg";
import globe from "../../assets/shapes_svg/dashboards/globe.svg";
import upArrow from "../../assets/shapes_svg/dashboards/up-arrow.svg";
import downArrow from "../../assets/shapes_svg/dashboards/down-arrow.svg";

function LangNav({ left }) {
  const [isClicked, setIsClicked] = useState(false);
  const [langSelected, setLangSelected] = useState(i18n.language || "da");
  const [isOpen, setIsOpen] = useState(false);

  // Load the language preference from localStorage when component mounts
  useEffect(() => {
    const savedLanguage = localStorage.getItem("preferredLanguage");
    if (savedLanguage) {
      setLangSelected(savedLanguage);
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  // Listen for language changes from i18n
  useEffect(() => {
    const handleLanguageChanged = (lng) => {
      setLangSelected(lng);
    };

    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (value) => {
    setLangSelected(value);
    i18n.changeLanguage(value);
    localStorage.setItem("preferredLanguage", value);
    setIsOpen(false);
  };

  const containerStyle = {
    position: "fixed",
    top: "20px",
    right: "0px",
    cursor: "pointer",
    zIndex: 9999,
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "auto",
  };

  return (
    <div className="usernametop__small sticky-langnav" style={containerStyle}>
      {!isClicked ? (
        <img
          src={dashGlobe}
          alt="Language change"
          width={54}
          height={54}
          onClick={() => setIsClicked(!isClicked)}
        />
      ) : (
        <div className="dash-lang" onClick={handleToggle}>
          <img src={globe} alt="Globe" width={30} height={30} />
          <div className="custom-select-container">
            <div className="custom-select-header">
              <span>{langSelected.toUpperCase()}</span>
              <span className="custom-arrow">
                {isOpen ? (
                  <img src={upArrow} width={20} height={20} alt="Up arrow" />
                ) : (
                  <img
                    src={downArrow}
                    width={20}
                    height={20}
                    alt="Down arrow"
                  />
                )}
              </span>
            </div>
            {isOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  right: "0",
                  zIndex: 99999999999,
                  backgroundColor: "none",
                  borderRadius: "4px",
                  marginTop: "5px",
                  cursor: "pointer",
                }}
              >
                <div className="chosen-lang">
                  {langSelected !== "en" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("en");
                      }}
                    >
                      EN
                    </div>
                  )}
                  {langSelected !== "da" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("da");
                      }}
                    >
                      DA
                    </div>
                  )}
                  {langSelected !== "fr" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("fr");
                      }}
                    >
                      FR
                    </div>
                  )}
                  {langSelected !== "de" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("de");
                      }}
                    >
                      DE
                    </div>
                  )}
                  {langSelected !== "nl" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("nl");
                      }}
                    >
                      NL
                    </div>
                  )}
                  {langSelected !== "id" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("id");
                      }}
                    >
                      ID
                    </div>
                  )}
                  {langSelected !== "it" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("it");
                      }}
                    >
                      IT
                    </div>
                  )}
                  {langSelected !== "es" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("es");
                      }}
                    >
                      ES
                    </div>
                  )}
                  {langSelected !== "pl" && (
                    <div
                      className="dropdown-option"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange("pl");
                      }}
                    >
                      PL
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default LangNav;
